export const CHANGE_LOGIN_STATE = 'CHANGE_LOGIN_STATE'